// Configuração centralizada da API

/**
 * Retorna a URL base da API dependendo do ambiente
 * Em produção: usa caminho relativo (mesmo domínio)
 * Em desenvolvimento: usa localhost:5000
 */
export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || (
    process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000'
  );
};

/**
 * Retorna a URL da API com /api no final
 * Para endpoints que precisam do sufixo /api
 */
export const getApiUrl = () => {
  const baseUrl = getApiBaseUrl();
  return baseUrl.endsWith('/api') ? baseUrl : `${baseUrl.replace(/\/$/, '')}/api`;
};

/**
 * Retorna a URL completa para um endpoint específico
 */
export const getEndpointUrl = (endpoint) => {
  const apiUrl = getApiUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${apiUrl}${cleanEndpoint}`;
};
